<template>
  <div>
    <div class="row mb-1 pb-3 mb-3 border-bottom g-0" style="--bs-border-color: black">
      <div class="col-md-12 d-flex align-items-center">
        <span class="fw-bold">Pemenuhan Kewajiban Pemegang PKKPRL/KKKPRL</span>
      </div>
    </div>

    <div class="d-flex kewajiban-layout">
      <div class="flex-grow-1 kewajiban-form">
        <b-form :key="currentPage" @submit.prevent>
          <h5>{{ formTitle[currentPage - 1] }}</h5>

          <div class="mb-3 mt-4">
            <label for="deskripsi">Deskripsi <span class="text-danger">*</span></label>
            <b-form-textarea
              id="deskripsi"
              v-model="currentForm.deskripsi"
              rows="5"
              placeholder="Masukkan deskripsi pemenuhan kewajiban"
              :disabled="is_selesai"
              @input="showValidationErrors = false"
            />
            <small v-if="showValidationErrors && !currentForm.deskripsi.trim()" class="text-danger">
              Deskripsi wajib diisi.
            </small>
          </div>

          <div class="mb-3">
            <label for="bukti-dukung">Bukti Dukung</label>
            <div class="d-flex gap-2">
              <b-form-file
                :key="`bukti-${currentPage}`"
                id="bukti-dukung"
                v-model="currentForm.bukti_dukung"
                accept=".pdf,application/pdf"
                placeholder="Pilih file PDF"
                drop-placeholder="Letakkan file PDF di sini"
                plain
                class="form-control"
                :disabled="is_selesai"
                @input="showValidationErrors = false"
              />
              <div>
                <a
                  :class="['btn btn-success', { disabled: !currentForm.id_file }]"
                  @click="unduhFile(currentForm.id_file)"
                >
                  <i class="fa fa-download" />
                  Unduh
                </a>
              </div>
            </div>
            <small class="form-text text-muted">Opsional. Format file: PDF.</small>
            <small v-if="currentForm.bukti_dukung" class="d-block text-muted">
              File terpilih: {{ currentForm.bukti_dukung.name }}
            </small>
            <small v-if="currentForm.bukti_dukung && !isPdfFile(currentForm.bukti_dukung)" class="text-danger">
              Bukti Dukung harus berupa file PDF.
            </small>
          </div>
        </b-form>
      </div>

      <aside class="ml-4 px-4 border-left kewajiban-pages">
        <div class="sticky-top" style="width: 220px; top: 50px; z-index: 100">
          <div class="text-center fw-bold">({{ currentPage }}/{{ totalPages }} halaman)</div>
          <div class="row g-0 mt-3">
            <div v-for="(title, index) in formTitle" :key="index" class="col-3 p-1" style="height: 50px">
              <button
                type="button"
                :class="[
                  'd-flex btn p-0 page-button',
                  index + 1 === currentPage ? 'btn-primary' : isPageComplete(index) ? 'btn-success' : 'btn-secondary',
                ]"
                :disabled="!is_selesai && !canOpenPage(index + 1)"
                :aria-label="`Buka halaman ${index + 1}`"
                @click="openPage(index + 1)"
              >
                <span class="m-auto">{{ index + 1 }}</span>
              </button>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-3">
            <div class="btn-group" role="group" aria-label="Navigasi halaman">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="currentPage === 1"
                @click="goToPage(currentPage - 1)"
              >
                <small><i class="fa fa-caret-left" /> Sebelumnya</small>
              </button>
              <button
                type="button"
                class="btn btn-primary border-left"
                :disabled="currentPage === totalPages"
                @click="goToPage(currentPage + 1)"
              >
                <small>Selanjutnya <i class="fa fa-caret-right" /></small>
              </button>
            </div>
          </div>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import api from '@/services/api'
import { isReadonlyStatus } from './statusRencanaAksi'

export default {
  data() {
    return {
      currentPage: 1,
      is_selesai: false,
      showValidationErrors: false,
      id_persiapan_penilaian: null,
      forms: Array.from({ length: 16 }, () => ({
        deskripsi: '',
        bukti_dukung: null,
        id_file: null,
      })),
      formTitle: [
        '1. Memperhatikan keberlanjutan kehidupan dan penghidupan Masyarakat',
        '2. Memberikan akses untuk nelayan kecil yang sudah secara rutin melintas',
        '3. Menghormati kepentingan pihak lain yang melakukan kegiatan atau Pemanfaatan Ruang di sekitarnya',
        '4. Melakukan kegiatan secara ramah lingkungan',
        '5. Menjaga kelestarian ekosistem Laut dan melakukan rehabilitasi sumber daya yang mengalami kerusakan',
        '6. Menjaga kehidupan dan alur migrasi biota laut',
        '7. Memberikan akses/tempat berlindung kepada siapapun dalam kondisi darurat',
        '8. Melibatkan dan memberdayakan Masyarakat sekitar lokasi kegiatan/usaha',
        '9. Membongkar bangunan dan instalasi di Laut apabila masa berlaku telah habis dan kegiatan/usaha tidak dilanjutkan lagi',
        '10. Tidak menimbulkan konflik sosial',
        '11. Tidak menimbulkan gangguan bagi pelaksanaan kepentingan keselamatan, pertahanan keamanan, dan memperhatikan kepentingan nasional',
        '12. Menyampaikan laporan perolehan Perizinan Berusaha/Perizinan Non Berusaha',
        '13. Menyampaikan laporan secara tertulis setiap 1 (satu) tahun kepada Menteri yang paling sedikit memuat:',
        '14. Bermitra dengan penglola Kawasan Konservasi di Laut dalam rangka program kemitraan dan bina lingkungan dalam hal lokasi kegiatan berada dalam Kawasan Konservasi di Laut',
        '15. Melaporkan pendirian dan/atau penempatan Bangunan dan Instalasi di Laut kepada instansi yang menyelenggarakan urusan pemerintahan di bidang hidrografi dan oseanografi',
        '16. Menyediakan prasarana dan sarana pencegahan pencemaran dan pencegahan kerusakan sumber daya ikan serta lingkungannya',
      ],
    }
  },
  inject: ['setPagePemenuhan', 'setIsSelesai'],
  computed: {
    totalPages() {
      return this.formTitle.length
    },
    currentForm() {
      return this.forms[this.currentPage - 1]
    },
  },
  mounted() {
    this.setPagePemenuhan(this.currentPage)
    this.loadData()
  },
  methods: {
    async resolveIdPersiapanPenilaian() {
      const existing = this.$route.query.id_persiapan_penilaian
      if (existing) return existing

      const id_rencana_aksi = this.$route.query.id_rencana_aksi
      if (!id_rencana_aksi) return null

      const res = await api.get(`api/persiapan_penilaian?filter=id_rencana_aksi,=,${id_rencana_aksi}`)
      const data = res.data?.data?.[0]
      if (!data?.id) return null

      await this.$router
        .replace({ path: this.$route.path, query: { ...this.$route.query, id_persiapan_penilaian: data.id } })
        .catch(() => {})
      return data.id
    },
    async loadData() {
      const id = await this.resolveIdPersiapanPenilaian()
      if (!id) return
      this.id_persiapan_penilaian = id

      this.$loading(true)
      try {
        const res = await api.get(`api/persiapan_penilaian/${id}`)
        const data = res.data?.data
        if (data) {
          this.applyPersiapanPenilaian(data)
          this.is_selesai = isReadonlyStatus(data.status)
          this.setIsSelesai(this.is_selesai)
        }
      } catch (error) {
        // tab ini awalnya kosong; biarkan kosong bila gagal memuat
      } finally {
        this.$loading(false)
      }
    },
    applyPersiapanPenilaian(data) {
      this.forms = this.forms.map((form, index) => {
        const n = index + 1
        return {
          ...form,
          deskripsi: data[`deskripsi_pemenuhan_${n}`] || '',
          id_file: data[`id_file_pemenuhan_${n}`] || null,
        }
      })
    },
    async unduhFile(id) {
      const res = await api.get(`api/files/download/${id}`, { responseType: 'blob' })
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },
    isPdfFile(file) {
      return !file || file.name.toLowerCase().endsWith('.pdf')
    },
    isPageComplete(index) {
      const form = this.forms[index]
      return Boolean(form.deskripsi.trim()) && this.isPdfFile(form.bukti_dukung)
    },
    canOpenPage(page) {
      return page === 1 || page === this.currentPage || this.isPageComplete(page - 1)
    },
    validateCurrentPage() {
      this.showValidationErrors = true
      return this.isPageComplete(this.currentPage - 1)
    },
    setCurrentPage(page) {
      this.currentPage = page
      this.showValidationErrors = false
      this.setPagePemenuhan(page)
    },
    nextPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) return
      if (!this.is_selesai && page > this.currentPage && !this.validateCurrentPage()) return

      this.setCurrentPage(page)
    },
    openPage(page) {
      if (!this.is_selesai && !this.canOpenPage(page)) return
      this.nextPage(page)
    },
    async goToPage(page) {
      if (page < 1 || page > this.totalPages || page === this.currentPage) return

      // mode readonly: cukup pindah halaman, tanpa validasi/simpan
      if (this.is_selesai) {
        this.setCurrentPage(page)
        return
      }

      // validasi hanya saat maju (perilaku lama dipertahankan)
      if (page > this.currentPage && !this.validateCurrentPage()) return

      // simpan dulu; bila gagal, jangan pindah
      if (!(await this.saveData())) return

      await this.loadData()
      this.setCurrentPage(page)
    },
    buildFormData() {
      const formData = new FormData()
      // prettier-ignore
      {
        formData.append('deskripsi_pemenuhan_1', this.forms[0].deskripsi)
        if (this.forms[0].bukti_dukung) formData.append('file_pemenuhan_1', this.forms[0].bukti_dukung)
        formData.append('deskripsi_pemenuhan_2', this.forms[1].deskripsi)
        if (this.forms[1].bukti_dukung) formData.append('file_pemenuhan_2', this.forms[1].bukti_dukung)
        formData.append('deskripsi_pemenuhan_3', this.forms[2].deskripsi)
        if (this.forms[2].bukti_dukung) formData.append('file_pemenuhan_3', this.forms[2].bukti_dukung)
        formData.append('deskripsi_pemenuhan_4', this.forms[3].deskripsi)
        if (this.forms[3].bukti_dukung) formData.append('file_pemenuhan_4', this.forms[3].bukti_dukung)
        formData.append('deskripsi_pemenuhan_5', this.forms[4].deskripsi)
        if (this.forms[4].bukti_dukung) formData.append('file_pemenuhan_5', this.forms[4].bukti_dukung)
        formData.append('deskripsi_pemenuhan_6', this.forms[5].deskripsi)
        if (this.forms[5].bukti_dukung) formData.append('file_pemenuhan_6', this.forms[5].bukti_dukung)
        formData.append('deskripsi_pemenuhan_7', this.forms[6].deskripsi)
        if (this.forms[6].bukti_dukung) formData.append('file_pemenuhan_7', this.forms[6].bukti_dukung)
        formData.append('deskripsi_pemenuhan_8', this.forms[7].deskripsi)
        if (this.forms[7].bukti_dukung) formData.append('file_pemenuhan_8', this.forms[7].bukti_dukung)
        formData.append('deskripsi_pemenuhan_9', this.forms[8].deskripsi)
        if (this.forms[8].bukti_dukung) formData.append('file_pemenuhan_9', this.forms[8].bukti_dukung)
        formData.append('deskripsi_pemenuhan_10', this.forms[9].deskripsi)
        if (this.forms[9].bukti_dukung) formData.append('file_pemenuhan_10', this.forms[9].bukti_dukung)
        formData.append('deskripsi_pemenuhan_11', this.forms[10].deskripsi)
        if (this.forms[10].bukti_dukung) formData.append('file_pemenuhan_11', this.forms[10].bukti_dukung)
        formData.append('deskripsi_pemenuhan_12', this.forms[11].deskripsi)
        if (this.forms[11].bukti_dukung) formData.append('file_pemenuhan_12', this.forms[11].bukti_dukung)
        formData.append('deskripsi_pemenuhan_13', this.forms[12].deskripsi)
        if (this.forms[12].bukti_dukung) formData.append('file_pemenuhan_13', this.forms[12].bukti_dukung)
        formData.append('deskripsi_pemenuhan_14', this.forms[13].deskripsi)
        if (this.forms[13].bukti_dukung) formData.append('file_pemenuhan_14', this.forms[13].bukti_dukung)
        formData.append('deskripsi_pemenuhan_15', this.forms[14].deskripsi)
        if (this.forms[14].bukti_dukung) formData.append('file_pemenuhan_15', this.forms[14].bukti_dukung)
        formData.append('deskripsi_pemenuhan_16', this.forms[15].deskripsi)
        if (this.forms[15].bukti_dukung) formData.append('file_pemenuhan_16', this.forms[15].bukti_dukung)
      }
      return formData
    },
    async saveData() {
      this.id_persiapan_penilaian = this.id_persiapan_penilaian || (await this.resolveIdPersiapanPenilaian())
      if (!this.id_persiapan_penilaian) {
        Swal.fire('Gagal', 'Lengkapi tab Identitas terlebih dahulu', 'error')
        return false
      }

      this.$loading(true)
      try {
        const res = await api.post(`api/persiapan_penilaian/${this.id_persiapan_penilaian}`, this.buildFormData())
        const saved = res.data?.data
        if (saved) {
          this.forms = this.forms.map((form, index) => ({
            ...form,
            bukti_dukung: null,
            id_file: saved[`id_file_pemenuhan_${index + 1}`] || form.id_file,
          }))
        }
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data'
        Swal.fire('Gagal', message, 'error')
        return false
      } finally {
        this.$loading(false)
      }
    },
    async nextForm() {
      if (this.is_selesai) return true
      if (this.currentPage !== this.totalPages) return false

      const invalidIndex = this.forms.findIndex((form, index) => !this.isPageComplete(index))
      if (invalidIndex !== -1) {
        this.setCurrentPage(invalidIndex + 1)
        this.showValidationErrors = true
        return false
      }

      if (!(await this.saveData())) return false

      Swal.fire('Berhasil', 'Pemenuhan Kewajiban tersimpan', 'success')
      return true
    },
    getFormData() {
      return this.forms.map((form, index) => ({
        halaman: index + 1,
        deskripsi: form.deskripsi,
        bukti_dukung: form.bukti_dukung,
      }))
    },
  },
}
</script>

<style scoped>
.kewajiban-form {
  min-width: 0;
}

.kewajiban-pages {
  flex: 0 0 252px;
}

.page-button {
  width: 100%;
  height: 100%;
}
</style>
